import React from "react";
import PageHeader from "../components/page-header";
import { Link } from "react-router-dom";
import ImageSlider from "../components/image-slider";

const SolutionsBusOperator = () => {
  return (
    <div className="page-inside page-booking-engine">
      <PageHeader page="bus-operator" />
      <div className="container">
        <p className="text-center mb-5">
          TravelCarma helps bus operators evolve reservation systems, route management, seat inventory, ticketing workflows, pricing control, and distribution networks into scalable, integration-ready operational platforms. Instead of replacing your existing infrastructure, TravelCarma extends and integrates your bus booking platform with CRM, accounting, reporting, and enterprise back-office systems — enabling scalable and AI-ready operational workflows.
        </p>

        <div className="solution-highlights mb-5">
          <div className="row">
            <div className="col-lg-6">
              <div className="d-flex align-items-center mt-3 mb-4 pb-4 border-bottom">
                <figure>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="48px"
                    viewBox="0 0 24 24"
                    width="48px"
                    fill="rgb(241, 130, 71)"
                  >
                    <path d="M0 0h24v24H0V0z" fill="none"></path>
                    <path d="M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"></path>
                  </svg>
                </figure>

                <h4 className="mb-0">Web Portals</h4>
              </div>
              <div className="d-flex align-items-center mb-4 pb-4">
                <figure>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="48px"
                    viewBox="0 0 24 24"
                    fill="rgb(241, 130, 71)"
                  >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M12 2c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4zm5.66 2.99H6.34C6.89 4.46 8.31 4 12 4s5.11.46 5.66.99zm.34 2V10H6V6.99h12zm-.34 9.74l-.29.27H6.63l-.29-.27C6.21 16.62 6 16.37 6 16v-4h12v4c0 .37-.21.62-.34.73z" />
                    <circle cx="8.5" cy="14.5" r="1.5" />
                    <circle cx="15.5" cy="14.5" r="1.5" />
                  </svg>
                </figure>
                <h4 className="mb-0">Bus Booking Engine</h4>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="d-flex align-items-center mt-3 mb-4 pb-4 border-bottom">
                <figure>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="48px"
                    viewBox="0 0 24 24"
                    fill="rgb(241, 130, 71)"
                  >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z" />
                  </svg>
                </figure>
                <h4 className="mb-0">Inventory Management System</h4>
              </div>
              <div className="d-flex align-items-center mb-4 pb-4">
                <figure>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="48px"
                    viewBox="0 0 24 24"
                    width="48px"
                    fill="rgb(241, 130, 71)"
                  >
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M0 0h24v24H0V0z" fill="none"></path>
                    <path d="M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"></path>
                  </svg>
                </figure>
                <h4 className="mb-0">Agency Management System</h4>
              </div>
            </div>
          </div>
        </div>

        <div className="row text-center solutions-section">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-5">
                <h2>Web Portals</h2>
                <p>
                  Deploy and modernize customer and agent-facing portals that integrate directly with your bus reservation workflows, route management systems, payment gateways, and back-office operations.
                </p>
                <button className="btn btn-primary">Discuss Your Bus Operations Modernization</button>
              </div>
              <div className="col-lg-7 d-flex">
                <div className="product-slider shadow-sm w-100">
                  <ImageSlider slider="BSS1" />
                </div>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">Website Configuration</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Configure your portal through CMS-based templates and manage content across pages, including text, images, videos, and forms with your branding. Support for multiple languages enables reach to customers across different regions.
                </p>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">Content Management</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Manage and customize web content through an intuitive CMS interface without requiring HTML knowledge or developer resources. Update portal content across all pages independently.
                </p>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">SEO Friendly</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  In order to make all your pages to be listed on search
                  engines, our CMS provides SEO friendly pages with the facility
                  to easily update the site's meta data such as page titles,
                  descriptions, image tags etc. You can easily submit your site
                  to search engines and also host the same content with minor
                  modifications for multiple domains.
                </p>
              </div>
            </div>
            <div className="solutions-separator"></div>
            <div className="row">
              <div className="col-lg-7 d-flex">
                <ImageSlider slider="BSS2" />
              </div>
              <div className="col-lg-5">
                <h2>Bus Booking Engine</h2>
                <p>
                  Modernize your bus booking workflows with integrated seat inventory management, pricing logic, e-ticket generation, payment orchestration, and CRM connectivity across web and mobile channels.
                </p>
                <button className="btn btn-primary">Discuss Your Bus Operations Modernization</button>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">
                  Website Integration
                </h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Integrate the bus booking engine with your existing website or CMS. Configure white-label or private-label variants that match your web environment. Enable downline partners to deploy branded booking engines on their own portals.
                </p>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">E-Ticket Generation and Confirmations</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Generate and deliver e-tickets with instant booking confirmations via email. Enable online modifications and cancellations. Provide registered customers access to booking history and reservation management.
                </p>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">Payment Integration and Processing</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Support multiple online and offline payment options including credit/debit cards, digital wallets, and cash. Integrate 40+ payment gateways globally. Add custom payment processors on demand.
                </p>
              </div>
            </div>
            <div className="solutions-separator"></div>
            <div className="row">
              <div className="col-lg-5">
                <h2>Inventory Management System</h2>
                <p>
                  Centralize and modernize your bus inventory, routes, schedules, pricing rules, and seat allocation through an integrated reservation and operations platform.
                </p>
                <button className="btn btn-primary">Discuss Your Bus Operations Modernization</button>
              </div>
              <div className="col-lg-7 d-flex">
                <ImageSlider slider="BSS3" />
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">Fleet and Operational Management</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Manage buses, schedules, fares, seat allocations, seasonal pricing, and amenities through the CRS. Define and enforce policies for reservations, modifications, and cancellations. Admin functions enable booking modifications. Role-based access controls secure all operational data.
                </p>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">Staff and Role Management</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Create staff accounts with role-based permissions (booking office, accounting, dispatch, supervision). Enable employees to process walk-in bookings, agent bookings, branch bookings, and privileged member bookings. Support hierarchical staff structures with sub-employee management.
                </p>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">Operational Reporting and Visibility</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Access dynamic dashboards showing business overview. Generate reports on bookings, cancellations, daily arrivals, inventory status, pricing, and billing. View data by agent, customer, or branch to support operational decision-making.
                </p>
              </div>
            </div>
            <div className="solutions-separator"></div>
            <div className="row">
              <div className="col-lg-7 d-flex">
                <ImageSlider slider="BSS4" />
              </div>
              <div className="col-lg-5">
                <h2>Agency Management System</h2>
                <p>
                  Modernize your B2B agency network with controlled portal access, pricing rules, commission management, reporting workflows, and integrated CRM and back-office connectivity.
                </p>
                <button className="btn btn-primary">Discuss Your Bus Operations Modernization</button>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">
                  Pricing and Commission Control
                </h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Manage agent networks through the system. Create, update, or suspend agent accounts. Configure individual pricing markups and commission structures. Block or restrict agent access as needed.
                </p>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">Data Security and Agent Branding</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Enforce role-based access controls and credential management for data security. Restrict agent visibility to authorized inventory and operations. Deploy co-branded agent interfaces with customizable look and feel.
                </p>
              </div>
              <div className="col-lg-4">
                <h5 className="mt-5 mb-3">Agent Reporting and Analytics</h5>
                <p
                  className="text-secondary"
                  style={{ fontSize: "1rem", lineHeight: "28px" }}
                >
                  Generate agent performance reports and commission calculations. Track revenue by agent, volume metrics, and business activity. Monitor agent-level operations for oversight and accounting reconciliation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionsBusOperator;
